"use client"

import { X, Check, ArrowLeft, Image, AlertCircle, Upload, PlayCircle } from "lucide-react"

export default function ContactModals({
  showAddContactModal,
  setShowAddContactModal,
  newContact,
  setNewContact,
  errors,
  setErrors,
  handleNewContactChange,
  handleAddContact,
  showMobileFilters,
  setShowMobileFilters,
  showBroadcastTemplateModal,
  broadcastStep,
  setBroadcastStep,
  selectedTemplate,
  templeteList,
  handleTemplateSelect,
  processTemplateContent,
  headerImage,
  setHeaderImage,
  isUploading,
  fileInputRef,
  handleImageUpload,
  templateVariables,
  variableInputs,
  autoFillOptions,
  handleVariableInputChange,
  toggleAutoFill,
  handleBroadcast,
  resetBroadcastModal,
  isBroadcasting,
  showImportPreviewModal,
  setShowImportPreviewModal,
  importedContacts,
  selectedImportedContacts,
  setSelectedImportedContacts,
  handleSelectAllImported,
  handleSelectImportedContact,
  handleSaveImportedContacts,
  handleBroadcastImported,
  isBroadcastingImported,
  tempBroadcastContacts,
  contacts,
  showToast,
  selectedContacts, // Declared selectedContacts here
}) {
  return (
    <>
      {/* Add Contact Modal */}
      {showAddContactModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto animate-[fadeIn_0.3s_ease-in-out]">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Add New Contact</h2>
                <button
                  onClick={() => {
                    setShowAddContactModal(false)
                    setNewContact({ name: "", number: "", tag: "", email: "", registerType: "contact" })
                    setErrors({})
                  }}
                  className="text-gray-400 hover:text-gray-500 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <p className="text-sm text-gray-500 mb-6">Add a new contact to your WhatsApp contacts list.</p>

              <form onSubmit={handleAddContact} className="space-y-4">
                <div className="space-y-2">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={newContact.name}
                    onChange={handleNewContactChange}
                    placeholder="Enter contact name"
                    className={`w-full px-3 py-2.5 border ${errors.name ? "border-red-500" : "border-gray-300"} rounded-md focus:outline-none focus:ring-2 focus:ring-[#001B3D] focus:border-transparent transition-colors`}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1 flex items-center">
                      <AlertCircle className="w-3 h-3 mr-1" /> {errors.name}
                    </p>
                  )}
                </div>
                <div className="space-y-2">
                  <label htmlFor="number" className="block text-sm font-medium text-gray-700">
                    Mobile Number
                  </label>
                  <input
                    id="number"
                    name="number"
                    type="text"
                    value={newContact.number}
                    onChange={handleNewContactChange}
                    placeholder="+91 XXXXXXXXXX"
                    className={`w-full px-3 py-2.5 border ${errors.number ? "border-red-500" : "border-gray-300"} rounded-md focus:outline-none focus:ring-2 focus:ring-[#001B3D] focus:border-transparent transition-colors`}
                  />
                  {errors.number && (
                    <p className="text-red-500 text-xs mt-1 flex items-center">
                      <AlertCircle className="w-3 h-3 mr-1" /> {errors.number}
                    </p>
                  )}
                </div>
                <div className="space-y-2">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={newContact.email}
                    onChange={handleNewContactChange}
                    placeholder="Enter email address"
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#001B3D] focus:border-transparent transition-colors"
                  />
                  <p className="text-xs text-gray-500">If left empty, default email will be used (contact@gmail.com)</p>
                </div>
                <div className="space-y-2">
                  <label htmlFor="tag" className="block text-sm font-medium text-gray-700">
                    Tag
                  </label>
                  <input
                    id="tag"
                    name="tag"
                    type="text"
                    value={newContact.tag}
                    onChange={handleNewContactChange}
                    placeholder="Enter tag"
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#001B3D] focus:border-transparent transition-colors"
                  />
                </div>
                <div className="pt-4">
                  <button
                    type="submit"
                    className="w-full bg-[#001B3D] text-white py-2.5 px-4 rounded-md hover:bg-[#002857] transition-all duration-200 shadow-sm hover:shadow"
                  >
                    Save Contact
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Filters Sidebar */}
      {showMobileFilters && (
        <div className="fixed inset-0 z-40 sm:hidden">
          <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowMobileFilters(false)}></div>
          <div className="absolute right-0 top-0 h-full w-[280px] bg-white shadow-xl p-4 overflow-y-auto animate-[slideInRight_0.3s_ease-in-out]">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-medium text-gray-900">Filter Contacts</h3>
              <button
                onClick={() => setShowMobileFilters(false)}
                className="text-gray-400 hover:text-gray-500 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-6">
              <div className="space-y-2">
                <h4 className="font-medium text-sm text-gray-700">Tags</h4>
                <div className="space-y-2">
                  <label className="flex items-center space-x-2">
                    <div
                      className="w-4 h-4 border border-gray-300 rounded flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors"
                      onClick={() => {
                        /* Toggle filter logic here */
                      }}
                    >
                      {/* Add state for filter checkboxes and conditionally render Check component */}
                    </div>
                    <span className="text-sm text-gray-700">CTWA Lead</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <div
                      className="w-4 h-4 border border-gray-300 rounded flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors"
                      onClick={() => {
                        /* Toggle filter logic here */
                      }}
                    >
                      {/* Add state for filter checkboxes and conditionally render Check component */}
                    </div>
                    <span className="text-sm text-gray-700">Customer</span>
                  </label>
                </div>
              </div>

              <div className="space-y-2">
                <h4 className="font-medium text-sm text-gray-700">Source</h4>
                <div className="space-y-2">
                  <label className="flex items-center space-x-2">
                    <div
                      className="w-4 h-4 border border-gray-300 rounded flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors"
                      onClick={() => {
                        /* Toggle filter logic here */
                      }}
                    >
                      {/* Add state for filter checkboxes and conditionally render Check component */}
                    </div>
                    <span className="text-sm text-gray-700">AD</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <div
                      className="w-4 h-4 border border-gray-300 rounded flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors"
                      onClick={() => {
                        /* Toggle filter logic here */
                      }}
                    >
                      {/* Add state for filter checkboxes and conditionally render Check component */}
                    </div>
                    <span className="text-sm text-gray-700">Manual</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <button
                className="w-full bg-[#001B3D] text-white py-2.5 px-4 rounded-md hover:bg-[#002857] transition-all duration-200 shadow-sm hover:shadow"
                onClick={() => setShowMobileFilters(false)}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Broadcast Template Modal */}
      {showBroadcastTemplateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto animate-[fadeIn_0.3s_ease-in-out]">
            <div className="p-6">
              {broadcastStep === 1 ? (
                // Template selection step
                <>
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-gray-900">Select Template for Broadcast</h2>
                    <button
                      onClick={resetBroadcastModal}
                      className="text-gray-400 hover:text-gray-500 transition-colors"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                  <p className="text-sm text-gray-500 mb-6">
                    Select a template to broadcast to{" "}
                    {isBroadcastingImported ? tempBroadcastContacts.length : selectedContacts.length} selected contact
                    {(isBroadcastingImported ? tempBroadcastContacts.length : selectedContacts.length) > 1 ? "s" : ""}
                  </p>

                  {/* Templates Table */}
                  <div className="overflow-x-auto rounded-md border border-gray-200 mb-6">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                            Select
                          </th>
                          <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                            Name
                          </th>
                          <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                            Category
                          </th>
                          <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                            Language
                          </th>
                          <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                            Content
                          </th>
                          <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {templeteList?.templates?.length > 0 ? (
                          templeteList.templates.map(
                            (template) =>
                              template.status === "APPROVED" && (
                                <tr
                                  key={template.id}
                                  className={`hover:bg-gray-50 cursor-pointer transition-colors ${
                                    selectedTemplate?.id === template.id ? "bg-gray-50" : ""
                                  }`}
                                  onClick={() => handleTemplateSelect(template)}
                                >
                                  <td className="px-4 py-4 text-sm">
                                    <div className="flex items-center justify-center">
                                      <div
                                        className={`w-5 h-5 border rounded-full flex items-center justify-center transition-colors ${
                                          selectedTemplate?.id === template.id
                                            ? "bg-[#001B3D] border-[#001B3D]"
                                            : "border-gray-300 hover:border-[#001B3D]"
                                        }`}
                                      >
                                        {selectedTemplate?.id === template.id && (
                                          <Check className="w-3 h-3 text-white" />
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="px-4 py-4 text-sm font-medium text-gray-900">{template.name}</td>
                                  <td className="px-4 py-4 text-sm text-gray-500">
                                    <span className="inline-flex items-center rounded-full bg-[#001B3D] bg-opacity-10 px-2.5 py-0.5 text-xs font-medium text-[#001B3D]">
                                      {template.category}
                                    </span>
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-500">{template.language}</td>
                                  <td className="px-4 py-4 text-sm text-gray-500 max-w-xs truncate">
                                    {template.components?.find((comp) => comp.type === "BODY")?.text
                                      ? processTemplateContent(
                                          template.components.find((comp) => comp.type === "BODY").text,
                                        )
                                      : "No content available"}
                                  </td>
                                  <td className="px-4 py-4 text-sm">
                                    <span
                                      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                        template.status === "APPROVED"
                                          ? "bg-green-100 text-green-800"
                                          : "bg-yellow-100 text-yellow-800"
                                      }`}
                                    >
                                      {template.status}
                                    </span>
                                  </td>
                                </tr>
                              ),
                          )
                        ) : (
                          <tr>
                            <td colSpan={6} className="px-4 py-4 text-center text-sm text-gray-500">
                              No templates found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Template Preview and Configuration Section */}
                  {selectedTemplate && (
                    <div className="mb-6 border rounded-lg overflow-hidden shadow-sm">
                      <div className="bg-gray-50 px-4 py-3 border-b">
                        <h3 className="font-medium text-gray-900">Template Preview</h3>
                      </div>
                      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Preview Panel */}
                        <div className="space-y-4">
                          <div className="bg-white border rounded-lg shadow-sm p-4">
                            {/* Header Preview */}
                            {selectedTemplate.components?.find((comp) => comp.type === "HEADER") && (
                              <div className="mb-3">
                                {selectedTemplate.components.find((comp) => comp.type === "HEADER").format ===
                                "IMAGE" ? (
                                  <div className="bg-gray-100 rounded-lg p-2 text-center">
                                    {headerImage ? (
                                      <img
                                        src={
                                          typeof headerImage === "string"
                                            ? headerImage
                                            : headerImage
                                              ? URL.createObjectURL(headerImage)
                                              : "/placeholder.svg"
                                        }
                                        alt="Header"
                                        className="max-h-48 mx-auto rounded-md"
                                      />
                                    ) : (
                                      <div className="h-32 flex items-center justify-center text-gray-500">
                                        <Image className="w-6 h-6 mr-2 text-gray-400" />
                                        <span>Image Header Required</span>
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="font-bold text-lg mb-2">
                                    {selectedTemplate.components.find((comp) => comp.type === "HEADER").text}
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Body Preview */}
                            <div className="mb-3 whitespace-pre-line">
                              {selectedTemplate.components?.find((comp) => comp.type === "BODY")?.text
                                ? processTemplateContent(
                                    selectedTemplate.components.find((comp) => comp.type === "BODY").text,
                                  )
                                : "No content available"}
                            </div>

                            {/* Footer Preview */}
                            {selectedTemplate.components?.find((comp) => comp.type === "FOOTER") && (
                              <div className="text-sm text-gray-500 italic">
                                {selectedTemplate.components.find((comp) => comp.type === "FOOTER").text}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Configuration Panel */}
                        <div className="space-y-4">
                          {/* Image Upload Section - Only show if template has IMAGE header */}
                          {selectedTemplate.components?.some(
                            (comp) => comp.type === "HEADER" && comp.format === "IMAGE",
                          ) && (
                            <div className="border rounded-md p-4">
                              <h4 className="font-medium text-gray-700 mb-2">Header Image</h4>
                              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-[#001B3D] transition-colors">
                                <div className="flex flex-col items-center justify-center">
                                  {isUploading ? (
                                    <div className="flex flex-col items-center justify-center py-4">
                                      <div className="w-8 h-8 border-4 border-t-[#001B3D] border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin mb-2"></div>
                                      <p className="text-sm text-gray-500">Uploading image...</p>
                                    </div>
                                  ) : headerImage ? (
                                    <div className="space-y-2 w-full">
                                      <div className="relative w-full max-w-md mx-auto">
                                        <img
                                          src={
                                            typeof headerImage === "string"
                                              ? headerImage
                                              : URL.createObjectURL(headerImage)
                                          }
                                          alt="Header preview"
                                          className="w-full h-auto rounded-lg shadow-md"
                                        />
                                        <button
                                          type="button"
                                          onClick={() => setHeaderImage(null)}
                                          className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md hover:bg-gray-100 transition-colors"
                                        >
                                          <X className="w-4 h-4 text-gray-700" />
                                        </button>
                                      </div>
                                      <p className="text-sm text-gray-500 text-center">
                                        {typeof headerImage === "string" ? "Uploaded image" : headerImage.name}
                                      </p>
                                    </div>
                                  ) : (
                                    <>
                                      <Upload className="w-10 h-10 text-gray-400 mb-2" />
                                      <p className="text-sm font-medium text-gray-700 mb-1">Upload header image</p>
                                      <p className="text-xs text-gray-500 mb-2">Required for this template</p>
                                      <button
                                        type="button"
                                        onClick={() => fileInputRef.current?.click()}
                                        className="px-3 py-1.5 bg-[#001B3D] text-white text-sm rounded-md hover:bg-[#002857] transition-all duration-200 shadow-sm hover:shadow"
                                      >
                                        Select Image
                                      </button>
                                      <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                        className="hidden"
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Variables Preview - Only show if template has variables */}
                          {Object.keys(templateVariables).length > 0 && (
                            <div className="border rounded-md p-4">
                              <h4 className="font-medium text-gray-700 mb-2">Template Variables</h4>
                              <p className="text-sm text-gray-500 mb-2">
                                This template contains {Object.keys(templateVariables).length} variable
                                {Object.keys(templateVariables).length !== 1 ? "s" : ""}. Click Next to configure them.
                              </p>
                              <div className="bg-gray-50 p-3 rounded text-sm">
                                {Object.keys(templateVariables).map((varNum) => (
                                  <div key={varNum} className="mb-1 flex items-center">
                                    <span className="font-medium text-[#001B3D] mr-1">Variable {varNum}:</span>
                                    <span className="bg-yellow-100 px-1 rounded">{templateVariables[varNum]}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex justify-end mt-6 gap-3">
                    <button
                      onClick={resetBroadcastModal}
                      className="px-4 py-2.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-all duration-200"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        if (selectedTemplate) {
                          // If there are variables, go to variable step, otherwise broadcast directly
                          if (Object.keys(templateVariables).length > 0) {
                            setBroadcastStep(2)
                          } else {
                            handleBroadcast()
                          }
                        }
                      }}
                      disabled={!selectedTemplate}
                      className={`px-4 py-2.5 rounded-md transition-all duration-200 ${
                        !selectedTemplate
                          ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                          : "bg-[#001B3D] text-white hover:bg-[#002857] shadow-sm hover:shadow"
                      }`}
                    >
                      {Object.keys(templateVariables).length > 0 ? "Next" : "Broadcast Now"}
                    </button>
                  </div>
                </>
              ) : (
                // Variables Step (now broadcastStep 2 or 3 depending on if image was required)
                <>
                  <div className="flex justify-between items-center mb-4">
                    <div className="flex items-center">
                      <button
                        onClick={() => setBroadcastStep(1)}
                        className="mr-3 text-gray-500 hover:text-gray-700 transition-colors"
                      >
                        <ArrowLeft className="w-5 h-5" />
                      </button>
                      <h2 className="text-xl font-semibold text-gray-900">Fill Template Variables</h2>
                    </div>
                    <button
                      onClick={resetBroadcastModal}
                      className="text-gray-400 hover:text-gray-500 transition-colors"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                  <p className="text-sm text-gray-500 mb-6">
                    Customize the template variables for "{selectedTemplate?.name}"
                  </p>

                  <div className="mb-6 border rounded-lg overflow-hidden shadow-sm">
                    <div className="bg-gray-50 px-4 py-3 border-b">
                      <h3 className="font-medium text-gray-900">Template Preview</h3>
                    </div>
                    <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Preview Panel */}
                      <div className="space-y-4">
                        <div className="bg-white border rounded-lg shadow-sm p-4">
                          {/* Header Preview */}
                          {selectedTemplate.components?.find((comp) => comp.type === "HEADER") && (
                            <div className="mb-3">
                              {selectedTemplate.components.find((comp) => comp.type === "HEADER").format === "IMAGE" ? (
                                <div className="bg-gray-100 rounded-lg p-2 text-center">
                                  {headerImage ? (
                                    <img
                                      src={
                                        typeof headerImage === "string"
                                          ? headerImage
                                          : headerImage
                                            ? URL.createObjectURL(headerImage)
                                            : "/placeholder.svg"
                                      }
                                      alt="Header"
                                      className="max-h-48 mx-auto rounded-md"
                                    />
                                  ) : (
                                    <div className="h-32 flex items-center justify-center text-gray-500">
                                      <Image className="w-6 h-6 mr-2 text-gray-400" />
                                      <span>Image Header Required</span>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="font-bold text-lg mb-2">
                                  {selectedTemplate.components.find((comp) => comp.type === "HEADER").text}
                                </div>
                              )}
                            </div>
                          )}

                          {/* Body Preview */}
                          <div className="mb-3 whitespace-pre-line">
                            {selectedTemplate.components?.find((comp) => comp.type === "BODY")?.text
                              ? processTemplateContent(
                                  selectedTemplate.components.find((comp) => comp.type === "BODY").text,
                                )
                              : "No content available"}
                          </div>

                          {/* Footer Preview */}
                          {selectedTemplate.components?.find((comp) => comp.type === "FOOTER") && (
                            <div className="text-sm text-gray-500 italic">
                              {selectedTemplate.components.find((comp) => comp.type === "FOOTER").text}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Configuration Panel */}
                      <div className="space-y-4">
                        {/* Image Upload Section - Only show if template has IMAGE header */}
                        {selectedTemplate.components?.some(
                          (comp) => comp.type === "HEADER" && comp.format === "IMAGE",
                        ) && (
                          <div className="border rounded-md p-4">
                            <h4 className="font-medium text-gray-700 mb-2">Header Image</h4>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-[#001B3D] transition-colors">
                              <div className="flex flex-col items-center justify-center">
                                {isUploading ? (
                                  <div className="flex flex-col items-center justify-center py-4">
                                    <div className="w-8 h-8 border-4 border-t-[#001B3D] border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin mb-2"></div>
                                    <p className="text-sm text-gray-500">Uploading image...</p>
                                  </div>
                                ) : headerImage ? (
                                  <div className="space-y-2 w-full">
                                    <div className="relative w-full max-w-md mx-auto">
                                      <img
                                        src={
                                          typeof headerImage === "string"
                                            ? headerImage
                                            : URL.createObjectURL(headerImage)
                                        }
                                        alt="Header preview"
                                        className="w-full h-auto rounded-lg shadow-md"
                                      />
                                      <button
                                        type="button"
                                        onClick={() => setHeaderImage(null)}
                                        className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md hover:bg-gray-100 transition-colors"
                                      >
                                        <X className="w-4 h-4 text-gray-700" />
                                      </button>
                                    </div>
                                    <p className="text-sm text-gray-500 text-center">
                                      {typeof headerImage === "string" ? "Uploaded image" : headerImage.name}
                                    </p>
                                  </div>
                                ) : (
                                  <>
                                    <Upload className="w-10 h-10 text-gray-400 mb-2" />
                                    <p className="text-sm font-medium text-gray-700 mb-1">Upload header image</p>
                                    <p className="text-xs text-gray-500 mb-2">Required for this template</p>
                                    <button
                                      type="button"
                                      onClick={() => fileInputRef.current?.click()}
                                      className="px-3 py-1.5 bg-[#001B3D] text-white text-sm rounded-md hover:bg-[#002857] transition-all duration-200 shadow-sm hover:shadow"
                                    >
                                      Select Image
                                    </button>
                                    <input
                                      ref={fileInputRef}
                                      type="file"
                                      accept="image/*"
                                      onChange={handleImageUpload}
                                      className="hidden"
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Variables Section */}
                        {Object.keys(templateVariables).length > 0 && (
                          <div className="border rounded-md p-4">
                            <h4 className="font-medium text-gray-700 mb-2">Template Variables</h4>
                            <div className="space-y-3">
                              {Object.keys(templateVariables).map((varNum) => (
                                <div key={varNum} className="space-y-2">
                                  <div className="flex justify-between items-center">
                                    <label className="block text-sm font-medium text-gray-700">
                                      Variable {varNum}: {templateVariables[varNum]}
                                    </label>
                                    <div className="flex items-center">
                                      <span className="text-sm text-gray-500 mr-2">Auto-fill</span>
                                      <button
                                        onClick={() => toggleAutoFill(varNum)}
                                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
                                          autoFillOptions[varNum] ? "bg-[#001B3D]" : "bg-gray-200"
                                        }`}
                                      >
                                        <span
                                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                                            autoFillOptions[varNum] ? "translate-x-6" : "translate-x-1"
                                          }`}
                                        />
                                      </button>
                                    </div>
                                  </div>

                                  {autoFillOptions[varNum] ? (
                                    <div className="bg-gray-100 p-2 rounded text-sm text-gray-700">
                                      {varNum === "1" ? (
                                        <div className="flex items-center">
                                          <Check className="w-4 h-4 text-green-500 mr-2" />
                                          <span>Will be replaced with contact name automatically</span>
                                        </div>
                                      ) : (
                                        <input
                                          type="text"
                                          value={variableInputs[varNum]}
                                          onChange={(e) => handleVariableInputChange(varNum, e.target.value)}
                                          placeholder={`Enter value for variable ${varNum}`}
                                          className="w-full px-3 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#001B3D] focus:border-transparent transition-colors"
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    <input
                                      type="text"
                                      value={variableInputs[varNum]}
                                      onChange={(e) => handleVariableInputChange(varNum, e.target.value)}
                                      placeholder={`Enter value for variable ${varNum}`}
                                      className="w-full px-3 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#001B3D] focus:border-transparent transition-colors"
                                    />
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end mt-6 gap-3">
                    <button
                      onClick={() => setBroadcastStep(1)}
                      className="px-4 py-2.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-all duration-200"
                    >
                      Back
                    </button>
                    <button
                      onClick={handleBroadcast}
                      className="px-4 py-2.5 rounded-md bg-[#001B3D] text-white hover:bg-[#002857] transition-all duration-200 shadow-sm hover:shadow"
                    >
                      Broadcast Now
                    </button>
                  </div>
                </>
              )}
            </div>
            {/* Broadcasting Loader */}
            {isBroadcasting && (
              <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex flex-col items-center justify-center">
                <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-xl flex flex-col items-center">
                  <div className="w-16 h-16 border-4 border-t-[#001B3D] border-r-[#001B3D] border-b-[#001B3D] border-l-transparent rounded-full animate-spin mb-6"></div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Broadcasting Messages</h3>
                  <p className="text-gray-600 text-center mb-4">
                    Sending template to {isBroadcastingImported ? tempBroadcastContacts.length : contacts.length}{" "}
                    contact
                    {(isBroadcastingImported ? tempBroadcastContacts.length : contacts.length) !== 1 ? "s" : ""}
                    ...
                  </p>
                  <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                    <div className="bg-[#001B3D] h-2 rounded-full animate-pulse"></div>
                  </div>
                  <p className="text-sm text-gray-500">Please don't close this window</p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Import Preview Modal */}
      {showImportPreviewModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col animate-[fadeIn_0.3s_ease-in-out]">
            <div className="p-6 overflow-y-auto flex-grow">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Review Imported Contacts</h2>
                <button
                  onClick={() => {
                    setShowImportPreviewModal(false)
                    setSelectedImportedContacts([])
                  }}
                  className="text-gray-400 hover:text-gray-500 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <p className="text-sm text-gray-500 mb-6">
                Review and confirm {importedContacts.length} contact{importedContacts.length !== 1 ? "s" : ""} imported
                from Excel. Select contacts to broadcast messages directly.
              </p>

              {/* Imported Contacts Table */}
              <div className="overflow-x-auto rounded-md border border-gray-200 mb-6">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-medium text-gray-700">
                        <div className="flex items-center justify-center">
                          <div
                            onClick={handleSelectAllImported}
                            className={`w-4 h-4 border border-gray-300 rounded flex items-center justify-center cursor-pointer transition-colors ${
                              selectedImportedContacts.length === importedContacts.length && importedContacts.length > 0
                                ? "bg-[#001B3D] border-[#001B3D]"
                                : "bg-white hover:bg-gray-100"
                            }`}
                          >
                            {selectedImportedContacts.length === importedContacts.length &&
                              importedContacts.length > 0 && <Check className="w-3 h-3 text-white" />}
                          </div>
                        </div>
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                        Name
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                        Mobile Number
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                        Country Code
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                        Email
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-medium text-gray-700">
                        Tag
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {importedContacts.map((contact, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-gray-50" : ""}>
                        <td className="whitespace-nowrap px-3 py-4 text-sm">
                          <div className="flex items-center justify-center">
                            <div
                              onClick={() => handleSelectImportedContact(index)}
                              className={`w-4 h-4 border border-gray-300 rounded flex items-center justify-center cursor-pointer transition-colors ${
                                selectedImportedContacts.includes(index)
                                  ? "bg-[#001B3D] border-[#001B3D]"
                                  : "bg-white hover:bg-gray-100"
                              }`}
                            >
                              {selectedImportedContacts.includes(index) && <Check className="w-3 h-3 text-white" />}
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-900">{contact.name}</td>
                        <td className="px-4 py-4 text-sm text-gray-500">{contact.number}</td>
                        <td className="px-4 py-4 text-sm text-gray-500">{contact.countryCode}</td>
                        <td className="px-4 py-4 text-sm text-gray-500">{contact.email || "contact@gmail.com"}</td>
                        <td className="px-4 py-4 text-sm">
                          <span className="inline-flex items-center rounded-full bg-[#001B3D] bg-opacity-10 px-2.5 py-0.5 text-xs font-medium text-[#001B3D]">
                            {contact.tag}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Fixed footer with buttons */}
            <div className="p-4 border-t border-gray-200 bg-white flex justify-between items-center sticky bottom-0 rounded-b-lg shadow-md">
              <div className="text-sm text-gray-500">
                {selectedImportedContacts.length > 0 ? (
                  <span>
                    {selectedImportedContacts.length} contact{selectedImportedContacts.length !== 1 ? "s" : ""} selected
                  </span>
                ) : (
                  <span>No contacts selected</span>
                )}
              </div>
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowImportPreviewModal(false)
                    setSelectedImportedContacts([])
                  }}
                  className="px-4 py-2.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveImportedContacts}
                  className="px-4 py-2.5 rounded-md bg-[#001B3D] text-white hover:bg-[#002857] transition-all duration-200 shadow-sm hover:shadow"
                >
                  Save Contacts
                </button>
                <button
                  onClick={handleBroadcastImported}
                  disabled={selectedImportedContacts.length === 0}
                  className={`px-4 py-2.5 rounded-md transition-all duration-200 flex items-center ${
                    selectedImportedContacts.length === 0
                      ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                      : "bg-[#001B3D] text-white hover:bg-[#002857] shadow-sm hover:shadow"
                  }`}
                >
                  <PlayCircle className="w-4 h-4 mr-2" /> Select & Broadcast
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

